// extracted by mini-css-extract-plugin
module.exports = {"back":"produit-module--back--25BCx","envelope":"produit-module--envelope--11yuk"};